import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 2.5rem 2rem;
  max-width: 800px;
  margin: 2.5rem auto;
  text-align: left;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.16);
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.highlight};
  margin-bottom: 1.5rem;
`;

const Lead = styled.p`
  font-size: 1.15rem;
  line-height: 1.8;
  color: #0b1120;
  margin-bottom: 1.75rem;
  font-weight: 500;
`;

const Paragraph = styled.p`
  font-size: 1.02rem;
  line-height: 1.75;
  color: #111827;
  margin-bottom: 1.1rem;
`;

const About = () => {
  return (
    <Container>
      <Title>About Sonna</Title>
      <Lead>
        Sonna is built with one simple belief: the tools tattoo artists use every day should be
        as thoughtful and intentional as the work they put on skin. This platform is made by artists,
        for artists.
      </Lead>
      <Paragraph>
        We know what it&apos;s like to juggle DMs, emails, last–minute reschedules, and clients in
        every time zone. Sonna is designed to reduce that noise. It brings your booking
        requests, client details, and AI-assisted messaging into one place, so you can spend less
        time chasing messages and more time tattooing.
      </Paragraph>
      <Paragraph>
        Our focus is on supporting professional artists and studios first. Clients interact with the
        platform only when needed to submit clear booking information and confirm appointments.
        Everything else is built around how you actually run your sessions, manage your calendar,
        and communicate with the people who trust you with their ideas.
      </Paragraph>
      <Paragraph>
        As Sonna grows, we&apos;ll continue to work closely with working artists to shape the
        roadmap. If there&apos;s a feature that would make your day in the studio easier, we want to hear
        about it.
      </Paragraph>
    </Container>
  );
};

export default About;
